import React, { Component } from "react";

import PropTypes from "prop-types";
import axios from "axios";



export class PostItem extends Component {
  state = {
    imgUrl: "",
    imgUrlTh: "",
    imgUrlMd: "",
    imgUrl600: "",
    isLoaded: false,
  };
  static propTypes = {
    post: PropTypes.object.isRequired,
  };

  componentDidMount() {
      //@ts-ignore
    const { featured_media } = this.props.post;
    const getImageUrl = axios.get(`https://obrien365.com/ob-wp/wp-json/wp/v2/media/${featured_media}`);

    Promise.all([getImageUrl]).then((res) => {
      console.log(res);
      this.setState({
        imgUrl: res[0].data.media_details.sizes.full.source_url,
        imgUrlTh: res[0].data.media_details.sizes.thumbnail.source_url,
        imgUrlMd: res[0].data.media_details.sizes.medium.source_url,
        
        imgUrl600: res[0].data.media_details.sizes.ob600.source_url,
        isLoaded: true,
      });
    });
  }

  render() {
      //@ts-ignore
    const { slug, title, content, acf } = this.props.post;
    const { imgUrl, imgUrlMd, imgUrl600, isLoaded } = this.state;
    if (isLoaded) {
      return (
        <section id={slug} className="ob-home-team catalog">
          
          <div className="team">
          <img src={imgUrl} srcSet={ imgUrlMd + ' 300w, ' + imgUrl600 + ' 630w,' } alt={title.rendered} />
          </div>
          
        </section>
      );
    }
    return null;
  }
}

export default PostItem;
